import { render, staticRenderFns } from "./elastic-product-list-subcategories.vue?vue&type=template&id=0a09858d"
import script from "./elastic-product-list-subcategories.vue?vue&type=script&lang=js"
export * from "./elastic-product-list-subcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports